import { render, staticRenderFns } from "./UsersPanel.vue?vue&type=template&id=1b9e56e0"
import script from "./UsersPanel.vue?vue&type=script&lang=js"
export * from "./UsersPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports